<div class='container'>
  <h1 style="text-align: center;">正在施工</h1>
  <p style="text-align: center;">
    <a routerLink="">
      <img src="assets/images/under-construction.png" alt="" width="50%">
    </a>
  </p>
</div>
